<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getAccounts"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
    

      <template v-slot:headings>
        <div class="col-md-3">Type</div>
        <div class="col-md-4">Name</div>
        <div class="col-md-2">Account</div>
        <div class="col-md-2 text-left text-md-right">Balance</div>
        <div class="col-md-1 text-left text-md-right">View</div>
      </template>

      <template v-slot:rows="slotProps">
      
        <div class="col-md-3 my-auto" v-if="slotProps.item.accountable" :class="{'text-danger faded' : slotProps.item.accountable.deleted_at != null}">
          <p class="m-0">{{ slotProps.item.accountable_type.replace('App\\','') }}</p>
        </div>

        <div class="col-md-4 my-auto" >
          <p class="m-0  font-weight-bold" v-if="slotProps.item.accountable" :class="{'text-danger faded' : slotProps.item.accountable.deleted_at != null}">
            {{ slotProps.item.accountable.name }}

           {{ slotProps.item.accountable.surname }}
          </p>
        </div>

         <div class="col-md-2 my-auto">
          <p class="m-0  font-weight-bold" v-if="slotProps.item.accountable" :class="{'text-danger faded' : slotProps.item.accountable.deleted_at != null}">{{ slotProps.item.account_type }}</p>
        </div>

          <div class="col-md-2 my-auto text-md-right">
          <p class="m-0  font-weight-bold" v-if="slotProps.item.accountable" :class="{'text-danger faded' : slotProps.item.accountable.deleted_at != null}">{{ slotProps.item.current_balance | currency }}</p>
        </div>

        <div class="col-md-1 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="view"
            :to="{
              name: 'accounts-account',
              params: { id: slotProps.item.id },
            }"
            class="text-info table-account-icon"
          >
            <i class="lni lni-search-alt"></i>
          </router-link>

          
        </div>
      </template>
    </data-table>

      

  
  </div>
</template>

<script>
import accountRepo from "@/api/repos/accountRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "current_balance", label: "Balance Highest", order: "desc" },
      sortOptions: [
       { column: "current_balance", label: "Balance Highest", order: "desc" },
       { column: "current_balance", label: "Balance Lowest", order: "asc" },
        { column: "id", label: "Id Asc", order: "asc" },
        { column: "id", label: "Id Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getAccounts({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      search: "",
    });
  },
  methods: {
  
    async getAccounts(e) {
      this.isLoad = true;
      try {
        let { data } = await accountRepo.accounts(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.accounts.data;
        this.totalRows = data.accounts.total;
        this.page = data.accounts.current_page;
        this.fromRow = data.accounts.from;
        this.toRow = data.accounts.to;
        this.lastPage = data.accounts.last_page;

        this.filterOptions = [];

        
          this.filterOptions.push({
            column: "accountable_type",
            value: "App\\Partner",
            label: "Partners"
          });

          this.filterOptions.push({
            column: "accountable_type",
            value: "App\\Client",
            label: "Clients"
          });

          this.filterOptions.push({
            column: "accountable_type",
            value: "App\\Supplier",
            label: "Suppliers"
          });
        



      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

   
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
